'use client'

import { createContext, useContext } from 'react'

export type MarkdownEditorRestoreContextValue = {
  isRestoreDialogOpen: boolean
  onRestore: () => void
  onDiscard: () => void
}

export const MarkdownEditorRestoreContext = createContext<MarkdownEditorRestoreContextValue | null>(
  null
)

export function useMarkdownEditorRestoreContext(): MarkdownEditorRestoreContextValue {
  const ctx = useContext(MarkdownEditorRestoreContext)
  if (!ctx) throw new Error('useMarkdownEditorRestoreContext must be used inside MarkdownEditor')
  return ctx
}
